import { isNotEmpty } from 'core/utils/form/functions'
import { CULTURES_COUNTRY } from '@openflex/component'
import getCultureCountry from './country'

export const getPower = (taxHorsepower = null, horsepower = null, kilowatt = null) => {
  switch (getCultureCountry()) {
    case CULTURES_COUNTRY.FR:
      return {
        complete: `${isNotEmpty(taxHorsepower) ? taxHorsepower : '-'} CV / ${
          isNotEmpty(horsepower) ? horsepower : '-'
        } ch`,
        value: `${isNotEmpty(taxHorsepower) ? taxHorsepower : '-'} / ${
          isNotEmpty(horsepower) ? horsepower : '-'
        }`,
        label: `CV - ch`
      }
    default:
      return {
        complete: `${isNotEmpty(horsepower) ? horsepower : '-'} ch / ${
          isNotEmpty(kilowatt) ? kilowatt : '-'
        } kW`,
        value: `${isNotEmpty(horsepower) ? horsepower : '-'} / ${
          isNotEmpty(kilowatt) ? kilowatt : '-'
        }`,
        label: `ch - kW`
      }
  }
}

export const getPlaceHolderNumberplate = () => {
  switch (getCultureCountry()) {
    default:
      return 'AA 001 ZZ'
  }
}
